import { compose } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { Col } from '../../../../../packages/kiti/components/structure/Grid'
import { useChangeSearch, useSearch } from '@btime/react-contexts'
import Form from '../../../../../components/form/Form'
import Input from '../../../../../components/form/Input'
import SeparatorWrapper from '../../../../../components/helpers/SeparatorWrapper'

const UsersSearchInput = React.memo(({ hideSearch }) => {
  const { t } = useTranslation('common')
  const finalSearch = useSearch()
  const [search, setSearch] = useState(finalSearch)

  const clearSearch = () => setSearch('')

  const setGlobalSearch = useChangeSearch()
  const updateQueryState = () => setGlobalSearch(search)
  const clearQueryState = () => setGlobalSearch('')

  const clearAndHideSearch = compose(clearQueryState, hideSearch, clearSearch)
  const onSubmit = compose(updateQueryState, hideSearch)
  const handleKeyDown = e => e.key === 'Escape' && onSubmit()

  return (
    <Col flex={1}>
      <SeparatorWrapper weight={2.5}>
        <Form onSubmit={onSubmit}>
          <Input
            placeholder={t('search')}
            autoFocus
            noBorder
            iconLeft="BsSearch"
            iconRight="BsX"
            iconRightAction={clearAndHideSearch}
            value={search}
            onChange={setSearch}
            onKeyDown={handleKeyDown}
          />
        </Form>
      </SeparatorWrapper>
    </Col>
  )
})

export default UsersSearchInput
